import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { type ReactNode, useState } from "react"

import { ToastProvider } from "@/components/ui/toast"

import { createQueryClient } from "./query-client"
import { ErrorBoundary } from "./error-boundary"

interface Props {
  children: ReactNode
}

export function AppProviders({ children }: Props): JSX.Element {
  const [queryClient] = useState(() => createQueryClient())

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          {children}
          {import.meta.env.DEV ? (
            <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
          ) : null}
        </ToastProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}
